import { defineComponent as _defineComponent } from 'vue'
import UploadPhoto from '@/components/format-edit/UploadPhoto.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoMainImageCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useRirekishoFormatData()
const { vm, globalVar, yagiprimePaymentService } = useHostServices()

function updateMainImage(data: string) {
  formatData.mainImageSrc = data
}

function deleteMainImage() {
  formatData.mainImageSrc = ''
}

function handleMainImageUploadClick() {
  yagiprimePaymentService.useFeature(vm, 'main-image-upload', {
    onSuccess: () => {},
    onCancel: () => {}
  })
}

return { __sfc: true,formatData, vm, globalVar, yagiprimePaymentService, updateMainImage, deleteMainImage, handleMainImageUploadClick, UploadPhoto }
}

})